import { formatUsd } from 'shared';

interface PriceDisplayProps {
  amount: number;
  unit?: string;
}

export function PriceDisplay({ amount, unit }: PriceDisplayProps) {
  return (
    <>
      {formatUsd(amount)}
      {unit !== undefined && <span className="sm-type-caption sm-muted sm-price-unit">{unit}</span>}
    </>
  );
}
